exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss"), undefined);

// module
exports.push([module.id, ".ActivateUser__surround___-1SwW {\n\tpadding: " + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["pagePadding"] + ";\n}\n\n.ActivateUser__label___1YI0K {\n\tdisplay: inline-block;\n\twidth: 5rem;\n\tfont-weight: bold;\n\ttext-align: right;\n    padding-right: 1rem;\n}\n\n.ActivateUser__value___1seyN {\n\tword-break: break-all;\n}\n\n.ActivateUser__lines___22WPo {\n\tmargin: 1rem 0;\n}\n\n.ActivateUser__profileImageLarge___3aDvb {\n\twidth: 80vw!important;\n\tmax-width: 80vw;\n\theight: 80vw!important;\n\tmax-height: 80vw;\n\toverflow: hidden;\n\tborder-radius: 100%;\n}\n\n.ActivateUser__expander___1lYbR {\n\tmargin-bottom: 1rem;\n}\n", ""]);

// exports
exports.locals = {
	"pagePadding": "" + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["pagePadding"] + "",
	"mainTextColour": "" + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["mainTextColour"] + "",
	"primaryColour": "" + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["primaryColour"] + "",
	"surround": "ActivateUser__surround___-1SwW",
	"label": "ActivateUser__label___1YI0K",
	"value": "ActivateUser__value___1seyN",
	"lines": "ActivateUser__lines___22WPo",
	"profileImageLarge": "ActivateUser__profileImageLarge___3aDvb",
	"expander": "ActivateUser__expander___1lYbR"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/ActivateUser.icss
// module id = 1545
// module chunks = 0